'use strict';

module.exports = {
    'af': require('./af.json'),
    'ak': require('./ak.json'),
    'am': require('./am.json'),
    'ar': require('./ar.json'),
    'as': require('./as.json'),
    'az': require('./az.json'),
    'be': require('./be.json'),
    'bg': require('./bg.json'),
    'bm': require('./bm.json'),
    'bn': require('./bn.json'),
    'bo': require('./bo.json'),
    'br': require('./br.json'),
    'bs': require('./bs.json'),
    'ca': require('./ca.json'),
    'cs': require('./cs.json'),
    'cy': require('./cy.json'),
    'da': require('./da.json'),
    'de': require('./de.json'),
    'dz': require('./dz.json'),
    'ee': require('./ee.json'),
    'el': require('./el.json'),
    'en': require('./en.json'),
    'eo': require('./eo.json'),
    'es': require('./es.json'),
    'et': require('./et.json'),
    'eu': require('./eu.json'),
    'fa': require('./fa.json'),
    'ff': require('./ff.json'),
    'fi': require('./fi.json'),
    'fo': require('./fo.json'),
    'fr': require('./fr.json'),
    'fy': require('./fy.json'),
    'ga': require('./ga.json'),
    'gd': require('./gd.json'),
    'gl': require('./gl.json'),
    'gu': require('./gu.json'),
    'gv': require('./gv.json'),
    'ha': require('./ha.json'),
    'he': require('./he.json'),
    'hi': require('./hi.json'),
    'hr': require('./hr.json'),
    'hu': require('./hu.json'),
    'hy': require('./hy.json'),
    'id': require('./id.json'),
    'ig': require('./ig.json'),
    'ii': require('./ii.json'),
    'is': require('./is.json'),
    'it': require('./it.json'),
    'ja': require('./ja.json'),
    'ka': require('./ka.json'),
    'ki': require('./ki.json'),
    'kk': require('./kk.json'),
    'kl': require('./kl.json'),
    'km': require('./km.json'),
    'kn': require('./kn.json'),
    'ko': require('./ko.json'),
    'ks': require('./ks.json'),
    'kw': require('./kw.json'),
    'ky': require('./ky.json'),
    'lb': require('./lb.json'),
    'lg': require('./lg.json'),
    'ln': require('./ln.json'),
    'lo': require('./lo.json'),
    'lt': require('./lt.json'),
    'lu': require('./lu.json'),
    'lv': require('./lv.json'),
    'mg': require('./mg.json'),
    'mk': require('./mk.json'),
    'ml': require('./ml.json'),
    'mn': require('./mn.json'),
    'mr': require('./mr.json'),
    'ms': require('./ms.json'),
    'mt': require('./mt.json'),
    'my': require('./my.json'),
    'nb': require('./nb.json'),
    'nd': require('./nd.json'),
    'ne': require('./ne.json'),
    'nl': require('./nl.json'),
    'nn': require('./nn.json'),
    'no': require('./no.json'),
    'om': require('./om.json'),
    'or': require('./or.json'),
    'os': require('./os.json'),
    'pa': require('./pa.json'),
    'pl': require('./pl.json'),
    'ps': require('./ps.json'),
    'pt': require('./pt.json'),
    'qu': require('./qu.json'),
    'rm': require('./rm.json'),
    'rn': require('./rn.json'),
    'ro': require('./ro.json'),
    'ru': require('./ru.json'),
    'rw': require('./rw.json'),
    'se': require('./se.json'),
    'sg': require('./sg.json'),
    'sh': require('./sh.json'),
    'si': require('./si.json'),
    'sk': require('./sk.json'),
    'sl': require('./sl.json'),
    'sn': require('./sn.json'),
    'so': require('./so.json'),
    'sq': require('./sq.json'),
    'sr': require('./sr.json'),
    'sv': require('./sv.json'),
    'sw': require('./sw.json'),
    'ta': require('./ta.json'),
    'te': require('./te.json'),
    'th': require('./th.json'),
    'ti': require('./ti.json'),
    'tl': require('./tl.json'),
    'to': require('./to.json'),
    'tr': require('./tr.json'),
    'ug': require('./ug.json'),
    'uk': require('./uk.json'),
    'ur': require('./ur.json'),
    'uz': require('./uz.json'),
    'vi': require('./vi.json'),
    'yi': require('./yi.json'),
    'yo': require('./yo.json'),
    'zh': require('./zh.json'),
    'zu': require('./zu.json')
};
